import {NestedTreeControl} from '@angular/cdk/tree';
import {Component, OnInit} from '@angular/core';
import {MatTreeNestedDataSource} from '@angular/material/tree';

interface FoodNode {
    name: string;
    children?: FoodNode[];
}

const TREE_DATA: FoodNode[] = [
    {
        name: 'Nomenclatures 1',
        children: [
            {name: 'Preservation of capital - ACTIVE'},
            {name: 'Income'},
            {name: 'Growth'},
        ]
    }, {
        name: 'Nomenclatures 2',
        children: [
            {name: 'Hedging'},
            {name: 'Trading Profits'},
            {name: 'Speculation'},
        ]
    },
];

@Component({
    selector: 'app-tree',
    templateUrl: './tree.component.html',
    styleUrls: ['./tree.component.scss']
})
export class TreeComponent implements OnInit {
    treeControl = new NestedTreeControl<FoodNode>(node => node.children);
    dataSource = new MatTreeNestedDataSource<FoodNode>();

    constructor() {
        this.dataSource.data = TREE_DATA;
    }

    ngOnInit() {
    }

    hasChild = (_: number, node: FoodNode) => !!node.children && node.children.length > 0;
}
